import { RELATIVE_PATH$ } from "./globals"

export const configuration = () => ({
    TOKEN_GETTER_URL: `${RELATIVE_PATH$.value}/api`
})